import { Dimension } from '@pubstack/common/src/analytics/dimension'
import { Scope } from '@pubstack/common/src/scope'
import { Timezone } from '@pubstack/common/src/timezone'
import { atom } from 'jotai'
import { atomWithReset } from 'jotai/utils'
import { DateTime } from 'luxon'
import { loadConfig } from '~/api/loadConfig'
import { FilterCategory } from '~/types/analytics'
import { Config } from '~/types/config'
import { getFilterSidebarContent } from '~/utils/analytics'

export const loadingState = atom<boolean>(false)

export const configurationState = atom<Promise<Config>>(loadConfig)

export type SidebarMenuOpen = {
  open: boolean
  pinned: boolean
}
export const sidebarOpenState = atom<SidebarMenuOpen>({
  open: true,
  pinned: true,
})

export type SidebarFilterPinned = {
  pinned: boolean
}
export const filterSidebarPinnedState = atom<SidebarFilterPinned>({
  pinned: true,
})

export const currentScopeState = atom<Scope>({
  id: '',
  name: '',
  enabled: false,
  pbjs: 'pbjs',
  currencyCode: 'EUR',
  gamKeyNamesForPrebid: ['hb_pb', 'hb_deal', 'hbv_pb'],
  timezone: 'Europe/Paris',
  mfaRequired: false,
})

export const contextState = atomWithReset<Context>({
  timeRange: {
    from: DateTime.local().startOf('day'),
    to: DateTime.local().endOf('day'),
    tz: 'Europe/Paris',
  },
  filters: {},
})

const configSidebar = getFilterSidebarContent()
const categoriesConfig: FilterCategory[] = [...configSidebar]
export const filterSidebarState = atom<FilterCategory[]>(categoriesConfig)

/** Easter egg. Set by the Konami code, it puts the `+30%` button in the header. */
export const konamiUnlockedState = atom<boolean>(false)

/** Easter egg. Set by that button, it swaps the whole app for a 404. A reload undoes it. */
export const upliftAppliedState = atom<boolean>(false)

export type Context = {
  timeRange: TimeRange
  filters: { [key in Dimension]?: Filter }
}

export type Filter = {
  mode: 'include' | 'exclude'
  name: Dimension
  values: {
    label: string
    sublabel?: string
    value: string
  }[]
}

export type TimeRange = {
  from: DateTime
  to: DateTime
  tz: Timezone
}
